import dataLayer from "@analytics/dataLayer";
import { getCookie } from "../utils/auth/cookies";

// The adapter resolves login page loads to 40.1 and login clicks to 28.2.
const page = { section: "Engage Login", name: "Login Page" };

const loginClick = (category, label, contentTitle) => {
  dataLayer.push({
    event: "click",
    page,
    interaction: { container: "Engage Login", category, label },
    ...(contentTitle && { content: { title: contentTitle } }),
  });
};

export const trackPageLoad = () => {
  dataLayer.push({ event: "page_view", page });
};

export const trackError = (errorTitle) => {
  loginClick("Error Message", errorTitle);
};

export const trackButtonClick = (label) => {
  loginClick("Button Click", label);
};

export const trackLogin = (method) => {
  // Format method strings like "SET_CREDENTIALAUTHENTICATION" into readable labels
  const formattedMethod = method
    ?.replaceAll("_", " ")
    .replaceAll(/([a-z])([A-Z])/g, "$1 $2");
  loginClick("Login", formattedMethod);
};

export const trackBiometricEvent = (label) => {
  loginClick("Biometric", label);
};

export const trackFederationClick = (type) => {
  const labels = {
    gst: "GST Button Click",
    set: "SET Button Click",
    tmna: "TMNA/TFS Button Click",
  };

  loginClick("Button Click", labels[type]);
};

export const trackForgeRockLoginSucceeded = () => {
  loginClick("Login", "Login Succeeded", getCookie("engageCorpUser"));
};

export const loginSucceeded = trackForgeRockLoginSucceeded;
